import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import { DomService } from 'app/components/dom/dom.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ExhibitorProfileService } from 'app/components/exhibitor-profile/exhibitor-profile.service';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { OdsService } from 'app/components/ods/ods.service';
import { SearchService } from 'app/components/search/search.service';
import { MapsService } from 'app/components/maps/maps.service';
import { UtilsService } from 'app/components/utils/utils.service';
import { DetailsService } from 'app/components/details/details.service';
import { ExhitorsService } from 'app/components/exhitors/exhitors.service';
import { FiltersService } from 'app/components/filters/filters.service';

@Component({
  selector: 'app-exhibitor-backoffice-exhibitor-detail-edit',
  templateUrl: './exhibitor-backoffice-exhibitor-detail-edit.component.html',
  styleUrls: ['./exhibitor-backoffice-exhibitor-detail-edit.component.css']
})
export class ExhibitorBackofficeExhibitorDetailEditComponent implements OnInit, OnDestroy {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  isOdsActive: boolean;

  catalogueId;
  eventName: string = '';
  exhibitorId;

  buttonLink: string = '';
  frontendLink: string = '';

  profile: object = {};

  exhibitorData: object = {
    exhibitor: {},
    exhibitorId: null,
    images: [],
    files: []
  };

  exhibitorStatuses: Array<any> = [];

  firaMaps: Array<any> = [];
  ods: Array<any> = [];
  files: Array<any> = [];
  baseDataLoaded: boolean = false;
  countriesMap: object = {};
  socialNetwork: Array<any> = [];
  categories: Array<any> = [];
  type:string = "EXHIBITOR";
  isFavorite: boolean = false;
  odsClass: string[] = [];

  activeTab: number = 1;

  selectedOds: Array<any> = [];

  constructor(private domService: DomService, private activatedRoute: ActivatedRoute, private exhibitorProfileService: ExhibitorProfileService,
  public catalogueService: CatalogueService, private exhitorsService: ExhitorsService, private odsService: OdsService, private searchService: SearchService,
  private mapsService: MapsService, public utilsService: UtilsService, public detailsService: DetailsService, private router: Router,
  private filtersService: FiltersService) {
    this.exhibitorId = this.activatedRoute.snapshot.paramMap.get('exhibitorId') || null;
    this.eventName = this.activatedRoute.snapshot.paramMap.get('event') || '';
    this.buttonLink = this.eventName + '/exhibitor-backoffice/exhibitors/' + this.exhibitorId + '/exhibitor-detail';
    this.frontendLink = this.catalogueService.getProperty('id') + '/' + this.eventName + '/exhibitor/' + this.exhibitorId + '/detail';
  }


  getSocialNetwork(getSocialNetworkIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.getSocialNetwork(getSocialNetworkIn)
      .subscribe((data: object) => {
        this.getSocialNetworkOk(data);
      },
        error => {
          this.getSocialNetworkError(error);
        });

  }

  getSocialNetworkOk(data) {

    this.loader.count--;
    this.socialNetwork = data;

  }

  getSocialNetworkError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getFiraMaps(getFiraMapsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.mapsService.getFiraMaps(getFiraMapsIn)
      .subscribe((data: object) => {
        this.getFiraMapsOk(data);
      },
        error => {
          this.getFiraMapsError(error);
        });

  }

  getFiraMapsOk(data) {

    this.loader.count--;
    this.firaMaps = data;

  }

  getFiraMapsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getCountriesInUse(getCountriesInUseIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.getCountriesInUse(getCountriesInUseIn)
      .subscribe((data: object) => {
        this.getCountriesInUseOk(data);
      },
        error => {
          this.getCountriesInUseError(error);
        });

  }

  getCountriesInUseOk(data) {

    this.loader.count--;
    this.countriesMap = {};
    data._embedded.countries.forEach(ctry => {
      this.countriesMap[ctry.id] = ctry;
      this.baseDataLoaded = true;
    });

  }

  getCountriesInUseError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
    this.baseDataLoaded = true;

  }

  fixUrl(url:string):string {
    if (typeof(url) === 'string') {
        if (!url.match(/http/)) {
            return 'http://'+url;
        }
        return url;
    }
    return url;
  }


  exhibitorHasSocialNetworks(exhibitor: any): boolean {
    if (!!exhibitor.facebookUrl || !!exhibitor.twitterUrl || !!exhibitor.instagramUrl || !!exhibitor.googlePlusUrl || !!exhibitor.linkedInUrl || !!exhibitor.flickrUrl || !!exhibitor.pinterestUrl) {
      return true;
    }
    return false;
  }



  cancel() {
    this.router.navigate([this.buttonLink]);
  }

   getOdsActive(getOdsActiveIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.odsService.getOdsActive(getOdsActiveIn)
      .subscribe((data: object) => {
        this.getOdsActiveOk(data);
      },
        error => {
          this.getOdsActiveError(error);
        });

  }

  getOdsActiveOk(data) {
    let getAllOdsIn = {
      eventName: this.eventName
    };

    this.loader.count--;
    this.isOdsActive = data;

    if(data) {
      this.getAllOds(getAllOdsIn);
    }
  }

  getOdsActiveError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getAllOds(getAllOdsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.filtersService.getOds(getAllOdsIn)
      .subscribe((data: object) => {
        this.getAllOdsOk(data);
      },
        error => {
          this.getAllOdsError(error);
        });

  }

  getAllOdsOk(data) {

    this.loader.count--;
    this.ods = data;

    let getOdsIn = {
      exhibitorId: this.exhibitorId
    }

    this.getOds(getOdsIn);

  }

  getAllOdsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getOds(getOdsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.odsService.getOds(getOdsIn)
      .subscribe((data: object) => {
        this.getOdsOk(data);
      },
        error => {
          this.getOdsError(error);
        });

  }


  getOdsOk(data) {

    this.loader.count--;
    this.exhibitorData['ods'] = data;

    for (let i = 0; i < this.ods.length; i++) {
      for (let j = 0; j < this.exhibitorData['ods'].length; j++) {
        if (this.exhibitorData['ods'][j].id === this.ods[i].id) {
          this.selectedOds.push(this.ods[i]['id']);
        }
      }
    }

  }

  getOdsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  checkSelectedOds(item) {

    if (this.selectedOds.indexOf(item) === -1) {
      return false;
    } else {
      return true;
    }

  }

  toggleOd(item) {

    let index = this.selectedOds.indexOf(item);

    if (index === -1) {
      this.selectedOds.push(item);
    } else {
      this.selectedOds.splice(index, 1);
    }

  }

  setTab(tab) {
    this.activeTab = tab;
  }


  saveExhibitor(saveExhibitorIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.saveExhibitor(saveExhibitorIn)
      .subscribe((data: object) => {
        this.saveExhibitorOk(data);
      },
        error => {
          this.saveExhibitorError(error);
        });

  }

  saveExhibitorOk(data) {

    this.loader.count--;
    this.router.navigate([this.buttonLink]);

  }

  saveExhibitorError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  saveBtn() {

    let saveExhibitorIn = this.exhibitorData['exhibitor'];
    saveExhibitorIn.descriptionTranslation = this.getDescriptionTranslations();
    saveExhibitorIn.exhibitorODS = this.selectedOds;
    saveExhibitorIn.eventName = this.eventName;
    saveExhibitorIn.properties = this.exhibitorData['exhibitor']['propertiesArray'];
    saveExhibitorIn.hierarchicalProperties = this.exhibitorData['selectedCategories'];
    saveExhibitorIn.masterProperties = [];

    // Remove unwanted properties:
    delete saveExhibitorIn.exhibitorStatusItem;
    delete saveExhibitorIn.cataloguePlansArray;
    delete saveExhibitorIn.cataloguePlan;
    delete saveExhibitorIn.sector;
    delete saveExhibitorIn.hierarchicalPropertiesArray;
    delete saveExhibitorIn.propertiesArray;
    delete saveExhibitorIn.sponsoredHierarchicalPropertiesArray;
    delete saveExhibitorIn.propertiesTree;
    delete saveExhibitorIn.masterProperties;
    delete saveExhibitorIn.translations;
    delete saveExhibitorIn._links;


    this.saveExhibitor(saveExhibitorIn);

  }

  getDescriptionTranslations() {

    let translations = {};
    this.exhibitorData['exhibitor']['translations'] = this.exhibitorData['exhibitor']['translations'] || [];

    for(let i = 0; i < this.exhibitorData['exhibitor']['translations'].length; i++) {
      let translation = this.exhibitorData['exhibitor']['translations'][i];
      translations[translation['language']] = translation['description'];
    }

    return translations;

  }

  goTo(url) {
    this.router.navigate([url]);
  }



  ngOnInit() {
    this.domService.addClassToBody('bg-gray');
    this.exhibitorData['exhibitorId'] = this.exhibitorId;
    this.exhibitorData['eventName'] = this.eventName;

    //this.searchConfig = this.searchService.getSearchConfig();
    //this.catalogueProperties = JSON.parse(this.sessionService.get('catalogueProperties') || '{}');

    //this.odsClass = Array(this.ods.length).fill('ods_img_little');
    //entityId
    
    let getSocialNetworkIn = {
      event: this.eventName
    };
    
    
    let getProjectionIn = {
      exhibitorId: this.exhibitorId ,
      projection: 'detail'
    };
    
    
    let getFiraMapsIn = {
      id: this.exhibitorId ,
      event:  this.eventName
    };

    this.getSocialNetwork(getSocialNetworkIn);
    this.getFiraMaps(getFiraMapsIn);

    let getOdsActiveIn = {
      eventName:  this.eventName
    }

    this.getOdsActive(getOdsActiveIn);


  }

  ngOnDestroy() {
    this.domService.removeClassFromBody('bg-gray');
  }

}
